<template>
    <div class="base-grid">
        <slot />
    </div>
</template>

<script setup>

</script>

<style lang="less">
.base-grid {
    display: grid;
    gap: var(--grid-gap-md);
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    width: 100%;
}

.base-grid--preset-1 {
    justify-content: center;
    justify-items: center;

    @media @mobile {
        grid-template-columns: repeat(auto-fit, 17.5rem);
        gap: 2rem;
    }

    @media @tablet {
        grid-template-columns: repeat(auto-fit, 23.75rem);
        gap: 2rem;
    }

    @media @desktop {
        grid-template-columns: repeat(auto-fit, 23.75rem);
        gap: 3rem;
    }
}
</style>
